// src/instance/index.ts
import { dynamicFunction } from "@lb-lib/dynamic-component";
var createInstance = dynamicFunction(async () => (await import("./create-KHWYPUSU.js")).createInstance);
var updateInstance = dynamicFunction(async () => (await import("./update-OXKDKKQF.js")).updateInstance);

// src/project/index.ts
import { dynamicFunction as dynamicFunction2 } from "@lb-lib/dynamic-component";
var createProject = dynamicFunction2(async () => (await import("./create-5EFNW6I6.js")).createProject);
var updateProject = dynamicFunction2(async () => (await import("./update-NXY6VSX3.js")).updateProject);

export {
  createInstance,
  updateInstance,
  createProject,
  updateProject
};
//# sourceMappingURL=chunk-V26GONG3.js.map